<template>
	<side-window :tabs="tabs" :active="active" class="settings" title="Indstillinger" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div>
			<form-grid-layout>
				<div v-show="active == 'branding'">
					<login-image-view :src="_background_src" v-model="model.branding.background" :changed.sync="model.branding.background_changed" style="width: 100%; height: 300px;" alt="/images/login-bg.jpg" />
					<string-view label="SMS afsender" v-model="model.text.sender" />
					<select-view label="Hovedrolle" v-model="model.branding.lead" :options="_employee_roles"/>
				</div>
				<div v-show="active == 'email'">
					<text-view :height="200" label="Skabelon for tilbud" v-model="model.email.quoteDefault" />
					<div class="edit__label">Vedhæft tilbud (privat)</div>
					<file-list-view v-model="model.email.quoteAtts" />	
					<div class="edit__label">Vedhæft tilbud (erhverv)</div>
					<file-list-view v-model="model.email.quoteAttsBizz" />						
				</div>
				<div v-show="active == 'email'">
					<text-view :height="200" label="Skabelon for ordre" v-model="model.email.orderDefault" />
					<div class="edit__label">Vedhæft ordrebekræftelse (privat)</div>
					<file-list-view v-model="model.email.orderAtts" />	
					<div class="edit__label">Vedhæft ordrebekræftelse (erhverv)</div>
					<file-list-view v-model="model.email.orderAttsBizz" />					
				</div>
				<div v-show="active == 'email'">
					<text-view :height="200" label="Signatur" v-model="model.email.signature" />					
				</div>
				<div v-show="active == 'instructions'">
					<string-view :optional="true" v-for="(instr, i) in instructions" :key="i" :height="50" :label="instr.label" v-model="model.instructions[instr.name]" />
				</div>
				<div v-show="active == 'private'">
					<text-view :height="200" label="Tilbud (pdf)" v-model="model.private.quote.pdf" />					
				</div>
				<div v-show="active == 'private'">
					<text-view :height="200" label="Tilbud (e-mail)" v-model="model.private.quote.email" />					
				</div>
				<div v-show="active == 'private'">
					<text-view :height="200" label="Ordrebrkræftelse (pdf)" v-model="model.private.order.pdf" />					
				</div>
				<div v-show="active == 'private'">
					<text-view :height="200" label="Ordrebrkræftelse (e-mail)" v-model="model.private.order.email" />					
				</div>
				<div v-show="active == 'business'">
					<text-view :height="200" label="Tilbud (pdf)" v-model="model.business.quote.pdf" />					
				</div>
				<div v-show="active == 'business'">
					<text-view :height="200" label="Tilbud (e-mail)" v-model="model.business.quote.email" />					
				</div>
				<div v-show="active == 'business'">
					<text-view :height="200" label="Ordrebekræftelse (pdf)" v-model="model.business.order.pdf" />					
				</div>
				<div v-show="active == 'business'">
					<text-view :height="200" label="Ordrebekræftelse (e-mail)" v-model="model.business.order.email" />					
				</div>
				<div v-show="active == 'templates'">
					<window-list-view :value="templates" :controller="templateController" />				
				</div>
				<div v-for="(role, i) in roles" v-bind:key="'roles' + i" v-show="active == 'roles'">
					<div class="side-window__heading">
						{{ role.label }}
						<switch-view :name="role.name" v-model="model.roles" />
					</div>
				</div>
				<div v-for="(task, i) in tasks" v-bind:key="'task' + i" v-show="active == 'tasks'">
					<div class="side-window__heading">
						{{ task.label }}
						<switch-view :name="task.name" v-model="model.tasks" />
					</div>
				</div>
				<div v-show="active == 'branding'">
					<string-view label="Medarbejderomkostning per time (privat)" v-model="model.economy.cost.man" />
					<string-view label="Køretøjomkostning per time (privat)" v-model="model.economy.cost.vehicle_hr" />
					<string-view label="Køretøjomkostning per km (privat)" v-model="model.economy.cost.vehicle_km" />
				</div>
				<div v-show="active == 'branding'">
					<string-view label="Medarbejderomkostning per time (erhverv)" v-model="model.economy.cost.man_biz" />
					<string-view label="Køretøjomkostning per time (erhverv)" v-model="model.economy.cost.vehicle_hr_biz" />
					<string-view label="Køretøjomkostning per km (erhverv)" v-model="model.economy.cost.vehicle_km_biz" />
				</div>
				<div v-show="active == 'integrations'">
					<div class="side-window__heading">
						Trustpilot
						<switch-view v-model="model.integrations.trustpilot.enabled" />
					</div>
					<string-view v-show="model.integrations.trustpilot.enabled" label="E-mail" v-model="model.integrations.trustpilot.email" />
					<string-view v-show="model.integrations.trustpilot.enabled" label="Adgangskode" v-model="model.integrations.trustpilot.password" />
				</div>
				<div v-show="active == 'integrations'">
					<div class="side-window__heading">
						e-conomic
						<switch-view v-model="model.integrations.economic.enabled" />
					</div>
					<select-view v-show="model.integrations.economic.enabled" label="App" :options="_economicApps" v-model="economicApp" />
					<string-view v-show="model.integrations.economic.enabled" label="ID" v-model="model.integrations.economic.id" />
					<button-view v-show="model.integrations.economic.enabled" label="Installer i e-conomic" @click="installEconomic" />
					<div class="side-window__heading" v-show="model.integrations.economic.enabled">Journal pr. betalingsmetode</div>
					<select-view v-show="model.integrations.economic.enabled" label="Kontant" :options="economicJournals" v-model="model.integrations.economic.journals.cash" />
					<select-view v-show="model.integrations.economic.enabled" label="Kort" :options="economicJournals" v-model="model.integrations.economic.journals.card" />
					<select-view v-show="model.integrations.economic.enabled" label="MobilePay" :options="economicJournals" v-model="model.integrations.economic.journals.mobilepay" />
					<select-view v-show="model.integrations.economic.enabled" label="Faktura" :options="economicJournals" v-model="model.integrations.economic.journals.invoice" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="save" />
		</div>
	</side-window>
</template>

<script>
	import SideWindow from '../../components/SideWindow'
	import FileListView from '../views/FileListView';

	import TemplateController from '../../components/TemplateController';

	import merge from '../functions/merge'

	export default {
		components: {
			sideWindow: SideWindow,
			fileListView: FileListView
		},
		data() {
			return {
				templateController: TemplateController,
				templates: [],
				active: 'branding',
				dummy: '',
				departments: [],
				instructions: [],
				roles: [],
				tasks: [],
				employeeRoles: [],
				economicJournals: [],
				model: {
					branding: {
						background: null,
						background_changed: false,
						lead: 'mover',
					},
					email: {
						quoteAtts: [],
						orderAtts: [],
						quoteAttsBizz: [],
						orderAttsBizz: [],
						quoteDefault: '',
						orderDefault: '',
						signature: 'Mvh,<br>\n{name}<br>\n{title}<br>\nmoovr'
					},
					text: {
						sender: 'moovr'
					},
					instructions: {},
					private: {
						quote: {
							pdf: '',
							email: ''
						},
						order: {
							pdf: '',
							email: ''
						}
					},
					business: {
						quote: {
							pdf: '',
							email: ''
						},
						order: {
							pdf: '',
							email: ''
						}
					},
					roles: [],
					tasks: [],
					economy: {
						cost: {
							man: '0',
							vehicle_hr: '0',
							vehicle_km: '0',
							man_biz: '0',
							vehicle_hr_biz: '0',
							vehicle_km_biz: '0',
						}
					},
					integrations: {
						economic: {
							enabled: false,
							id: '',
							app: null,
							journals: { cash: null, card: null, mobilepay: null, invoice: null }
						},
						trustpilot: {
							enabled: false,
							email: '',
							password: ''
						}
					}
				}
			};
		},
		computed: {
			_economicApps() {
				return [
					{ value: 'sales', label: 'Sales' },
					{ value: 'sales_accounting', label: 'Sales & accounting' }
				];
			},
			economicApp: {
				get() {
					return this.model.integrations.economic.app || 'sales';
				},
				set(v) {
					this.model.integrations.economic.app = v;
				}
			},
			_employee_roles() {
				return this.employeeRoles.map(role => { 
					return {
						value: role.name,
						label: role.label
					};
				});
			},
			tabs: function () {
				return [
					{
						name: 'branding',
						label: 'Tilpas'
					},
					{
						name: 'email',
						label: 'E-mail'
					},
					{
						name: 'instructions',
						label: 'Instruktioner'
					},
					{
						name: 'templates',
						label: 'Skabeloner'
					},
					{
						name: 'roles',
						label: 'Roller'
					},
					{
						name: 'tasks',
						label: 'Opgaver'
					},
					{
						name: 'integrations',
						label: 'Integrationer'
					}
				];
			},
			_background_src() {
				return `${process.env.VUE_APP_API}/customers/${this.$store.state.employee.customer_id}/background`;
			}
		}, 
		methods: {
			installEconomic() {
				window.open('https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=WxYl1hIyM2M267LCKFbcwuDovDZJrBNB2pwDbHZqLpo', '_blank');
			},
			bum() {
				
			},
			save() {
				

				var self = this;

				this.axios
					.put('/us/settings/', this.model)
					.then(function (r) {
						self.$emit('close');

						// Re-init settings
						self.$store.dispatch('update', self.axios);
					}, function () {
						
					});
			},
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			roleInput() {

			}
		},
		async mounted() {
			var self = this;

			this.axios
				.get('/us/settings/')
				.then(function (r) {
					self.model = merge(self.model, r.data);
				}, function () {
					
				});

			this.axios
				.get('/integrations/economic/journals/')
				.then(function (r) {
					self.economicJournals = r.data.map(function (j) { return { label: j.name, value: j.journalNumber }; });
				}, function () {
					
				});

			this.axios
				.get('/tasks/instructions/')
				.then(function (r) {
					for (var i = 0; i < r.data._items.length; ++i) {
						if (!self.model.instructions.hasOwnProperty(r.data._items[i].name)) {
							self.model.instructions[r.data._items[i].name] = '';
						}
					}

					self.instructions = r.data._items;

					
				}, function () {
					
				});

			var employeeRoles = (await this.axios.get('/employees/roles/')).data._items;
			var vehicleRoles = (await this.axios.get('/fleet/vehicles/roles/')).data._items;

			this.employeeRoles = employeeRoles;
			this.roles = employeeRoles.concat(vehicleRoles);

			this.tasks = (await this.axios.get('/tasks/types/')).data._items;
		}
	}
</script>

<style lang="scss">
	.settings {
		.edit__label {
			position: relative;
			pointer-events: none;
			left: 0;
			top: 0;
			font-size: 12px;
			color: #555963;
			margin-bottom: 10px;
		}
	}
</style>
